import React, { useState } from 'react';
import './LoginTab.css';
import { supabase } from '../App';

const LoginTab = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError(null);

    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: { redirectTo: `${window.location.origin}/deals` },
      });

      if (error) throw error;
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="login-tab">
      <div className="login-container">
        <h2>Sign In</h2>

        {error && <div className="error-message">{error}</div>}

        <button
          type="button"
          className="auth-button"
          onClick={handleGoogleSignIn}
          disabled={loading}
        >
          {loading ? 'Redirecting...' : 'Sign in with Google'}
        </button>
      </div>
    </div>
  );
};

export default LoginTab;
